import { APIClient } from "../helpers/api_helper";

const api = new APIClient();
const RESOURCE = "/email-campaigns";

export type EmailCampaignStatus = "draft" | "scheduled" | "sending" | "sent" | "canceled";

export interface EmailCampaignStats {
  sent: number;
  bounced: number;
  complained: number;
  skipped_suppressed: number;
  failed: number;
  opted_out: number;
}

export interface EmailCampaign {
  id: number;
  name: string;
  template_key: string;
  segment: { inactive_days?: number };
  status: EmailCampaignStatus;
  scheduled_at: string | null;
  sent_at: string | null;
  recipients_count: number | null;
  created_at: string;
  stats?: EmailCampaignStats;
}

export interface EmailCampaignUsage {
  transactional_count: number;
  campaign_count: number;
  campaign_quota: number;
  limit: number | null;
  is_free: boolean;
  is_near_limit: boolean;
  is_at_limit: boolean;
  is_campaign_near_limit: boolean;
  is_campaign_at_limit: boolean;
}

export interface EmailCampaignListData {
  campaigns: {
    data: EmailCampaign[];
    current_page: number;
    last_page: number;
    total: number;
  };
  usage: EmailCampaignUsage;
  estimate: {
    inactive_days: number;
    eligible_count: number;
  };
  reactivation_campaigns_enabled?: boolean;
}

export interface EmailCampaignPreview {
  subject: string;
  html: string;
}

export const listEmailCampaigns = async (): Promise<{
  success: boolean;
  data: EmailCampaignListData;
  message?: string;
}> => api.get(RESOURCE);

export const getEmailCampaignPreview = async (): Promise<{
  success: boolean;
  data: EmailCampaignPreview;
  message?: string;
}> => api.get(`${RESOURCE}/preview`);

export const createEmailCampaign = async (payload: {
  name: string;
  template_key?: string;
  segment?: { inactive_days?: number };
  scheduled_at?: string | null;
}): Promise<{ success: boolean; data: EmailCampaign; message?: string }> =>
  api.create(RESOURCE, payload);

export const sendEmailCampaign = async (
  id: number
): Promise<{ success: boolean; data: EmailCampaign; message?: string }> =>
  api.create(`${RESOURCE}/${id}/send`, {});

export const getEmailCampaignStats = async (
  id: number
): Promise<{
  success: boolean;
  data: { campaign: EmailCampaign; stats: EmailCampaignStats };
  message?: string;
}> => api.get(`${RESOURCE}/${id}/stats`);
